/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { FunctionComponent, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { mqMax, mqMin } from '../../GlobalStyle'
import { Button } from '../Button'
import { AppIcon } from '../Icon'

type FeedbackThankYouProps = {
    backButtonText: string
    backButtonPath: string
}

const FeedbackThankYou: FunctionComponent<React.PropsWithChildren<FeedbackThankYouProps>> = ({ backButtonText, backButtonPath }) => {
    const navigate = useNavigate()

    const onBackButtonClick = useCallback(() => {
        navigate(backButtonPath)
    }, [navigate, backButtonPath])

    return (
        <div
            css={css`
                display: flex;
                box-sizing: border-box;
                flex-direction: column;
                height: calc(100vh - 57px);
                padding: 24px 10%;
            `}
        >
            <div
                css={css`
                    max-width: 500px;
                    margin: auto;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    flex: 1;

                    ${mqMin[1]} {
                        padding-bottom: 88px;
                    }
                `}
            >
                <AppIcon
                    status='static'
                    name='trophy'
                    size={100}
                    css={css`
                        margin: 0 auto 32px auto;
                    `}
                />
                <h3
                    css={css`
                        margin-bottom: 30px;
                    `}
                >
                    Thank you for sharing your feedback!
                </h3>

                <p
                    css={css`
                        max-width: 398px;
                    `}
                >
                    We are constantly working to improve our Booking Request process at Talent Alpha and your feedback is important to us.
                </p>

                <Button
                    variant='primary'
                    onClick={onBackButtonClick}
                    style={css`
                        margin-top: 18px;
                        width: 188px;

                        ${mqMax[1]} {
                            width: 100%;
                        }
                    `}
                >
                    {backButtonText}
                </Button>
            </div>
        </div>
    )
}

export { FeedbackThankYou }
